import { render, staticRenderFns } from "./WithdrawalGoalsDistribution.vue?vue&type=template&id=68ec40c1&scoped=true&"
import script from "./WithdrawalGoalsDistribution.vue?vue&type=script&lang=ts&"
export * from "./WithdrawalGoalsDistribution.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawalGoalsDistribution.vue?vue&type=style&index=0&id=68ec40c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec40c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VImg,VRow,VTextField})
